var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCloseFilledIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3428_57546)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.5 0.625C3.70312 0.625 0.625 3.70312 0.625 7.5C0.625 11.2969 3.70312 14.375 7.5 14.375C11.2969 14.375 14.375 11.2969 14.375 7.5C14.375 3.70312 11.2969 0.625 7.5 0.625ZM9.81687 6.06687C9.93072 5.949 9.99372 5.79112 9.9923 5.62725C9.99087 5.46338 9.92514 5.30662 9.80926 5.19074C9.69338 5.07486 9.53662 5.00913 9.37275 5.0077C9.20888 5.00628 9.051 5.06928 8.93313 5.18313L7.5 6.61625L6.06687 5.18313C6.00922 5.12343 5.94026 5.07582 5.864 5.04306C5.78775 5.01031 5.70574 4.99306 5.62275 4.99234C5.53976 4.99162 5.45746 5.00744 5.38065 5.03886C5.30384 5.07029 5.23406 5.1167 5.17538 5.17538C5.1167 5.23406 5.07029 5.30384 5.03886 5.38065C5.00744 5.45746 4.99162 5.53976 4.99234 5.62275C4.99306 5.70574 5.01031 5.78775 5.04306 5.864C5.07582 5.94026 5.12343 6.00922 5.18313 6.06687L6.61625 7.5L5.18313 8.93313C5.12343 8.99078 5.07582 9.05974 5.04306 9.136C5.01031 9.21225 4.99306 9.29426 4.99234 9.37725C4.99162 9.46024 5.00744 9.54254 5.03886 9.61935C5.07029 9.69616 5.1167 9.76594 5.17538 9.82462C5.23406 9.8833 5.30384 9.92971 5.38065 9.96114C5.45746 9.99256 5.53976 10.0084 5.62275 10.0077C5.70574 10.0069 5.78775 9.98969 5.864 9.95694C5.94026 9.92418 6.00922 9.87657 6.06687 9.81687L7.5 8.38375L8.93313 9.81687C9.051 9.93072 9.20888 9.99372 9.37275 9.9923C9.53662 9.99087 9.69338 9.92514 9.80926 9.80926C9.92514 9.69338 9.99087 9.53662 9.9923 9.37275C9.99372 9.20888 9.93072 9.051 9.81687 8.93313L8.38375 7.5L9.81687 6.06687Z",
    fill: "#D9D9D9"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3428_57546"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 15,
    height: 15,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloseFilledIcon);
export default __webpack_public_path__ + "static/media/close-filled-icon.17d2e5978bc28543b30077242000b548.svg";
export { ForwardRef as ReactComponent };